<template lang="pug">
div
  div(v-show="false" v-html="svgSprite")
  .l-page
    .l-page__content
      Navigation
      transition(name="fade-short" v-on:after-leave="scrollToTop")
        router-view
      Footer
  transition(name="fade-short")
    #spinner.l-spinner.l-spinner--risk-object(style="display: block" v-if="loading")
      .l-spinner__label {{$t('profiles.please_wait')}}
      .l-spinner__circle
</template>

<script>
import '@/assets/stylesheets/main.scss'

import axios from 'axios'
import Navigation from './components/layout/Navigation'
import Footer from './components/layout/Footer'

export default {
  data () {
    return {
      svgSprite: ''
    }
  },
  name: 'app',
  components: {
    Navigation,
    Footer
  },
  mounted () {
    this.$store.commit('setLoading', false)
    this.setSvgSprite()
    // As it's'been decided that the checkup app would no longer be maintained
    // and would only exist on its own, all the couplings with SW have been
    // decommissionned. We thus don't fetch User data from SW anymore.
    // this.getUserInfos()
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    seraphinPath () {
      return process.env.SERAPHIN_PATH
    }
  },
  methods: {
    // getUserInfos () {
    //   if (this.$route.query.token) {
    //     localStorage.clear()
    //     axios.post(`${this.seraphinPath}/fr/checkups/user_data`, {token: this.$route.query.token})
    //     .then(res => {
    //       this.$store.commit('parseCheckupData', res.data)
    //     })
    //     .catch(err => {
    //       console.log(err)
    //     })
    //   }
    // },
    setSvgSprite () {
      axios.get('./static/assets/img/sprite.svg')
      .then(res => {
        this.svgSprite = res.data
      })
    },
    scrollToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style>
/* Transition between the pages */
.fade-short-enter-active, .fade-short-leave-active {
  transition: opacity .3s;
}

.fade-short-enter-active {
  transition-delay: .3s;
}

.fade-short-enter, .fade-short-leave-active {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/App.vue